define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerExternalUserModel = /** @class */ (function () {
        function CustomerExternalUserModel(data) {
            this.Id = ko.observable(0);
            this.LoginId = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.UserName = ko.observable();
            this.FirstName = ko.observable();
            this.LastName = ko.observable();
            this.AllowedDomains = ko.observableArray();
            this.AllowedDomainsStr = ko.observable();
            this.RoleId = ko.observable(0);
            this.RoleName = ko.observable();
            this.CanEditRole = ko.observable(true);
            this.DisabledInput = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerExternalUserModel.Mapping, self);
            }
        }
        CustomerExternalUserModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerExternalUserModel(options.data);
            }
        };
        return CustomerExternalUserModel;
    }());
    return CustomerExternalUserModel;
});
//# sourceMappingURL=CustomerExternalUserModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerExternalUserModel.js
// module id = 180
// module chunks = 2